// 图书多元数据模块
const state = {
  // 图书多元（日/周/月）
  tushuduoyuan: {
    period: 'today',
    day: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
    week: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
    month: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 }
  }
}

const mutations = {
  // 设置图书多元数据（日/周/月）
  SET_TUSHUDUOYUAN(state, payload) {
    const safeNum = v => {
      const n = Number(v)
      return isNaN(n) ? 0 : n
    }
    const normalize = obj => ({
      jybs: safeNum(obj?.jybs),
      zmy: safeNum(obj?.zmy),
      tbzmy: safeNum(obj?.tbzmy),
      hbzmy: safeNum(obj?.hbzmy)
    })
    if (payload?.day) state.tushuduoyuan.day = normalize(payload.day)
    if (payload?.week) state.tushuduoyuan.week = normalize(payload.week)
    if (payload?.month) state.tushuduoyuan.month = normalize(payload.month)
    if (payload?.period) state.tushuduoyuan.period = payload.period
  },
  // 重置图书多元数据
  RESET_BOOK(state) {
    state.tushuduoyuan = {
      period: 'today',
      day: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
      week: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
      month: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 }
    }
  }
}

const actions = {
  // 获取图书多元数据 （日/周/月）
  async fetchBookStatistics({ commit, rootState }) {
    try {
      const big = rootState.screen.screenData || {}

      // 将可能带有逗号、百分号或中文单位（万、亿）的字符串统一转换为数值（单位：元）
      const safeNum = (v) => {
        if (v === null || v === undefined) return 0
        if (typeof v === 'number' && !isNaN(v)) return v
        const s = String(v).trim()
        if (!s) return 0
        // 去掉千位分隔与百分号
        const cleaned = s.replace(/,/g, '').replace(/%/g, '')
        // 处理中文单位：万、亿
        if (/万$/.test(cleaned)) {
          const n = parseFloat(cleaned.replace('万', ''))
          return isNaN(n) ? 0 : n * 10000
        }
        if (/亿$/.test(cleaned)) {
          const n = parseFloat(cleaned.replace('亿', ''))
          return isNaN(n) ? 0 : n * 100000000
        }
        const n = parseFloat(cleaned)
        return isNaN(n) ? 0 : n
      }

      // 规范化图书多元对象结构为 { jybs, zmy, tbzmy, hbzmy }
      const normalizeDU = (obj) => ({
        jybs: safeNum(obj?.jybs),     // 交易笔数（笔）
        zmy: safeNum(obj?.zmy),       // 总码洋（元）
        tbzmy: safeNum(obj?.tbzmy),   // 同比总码洋（元）
        hbzmy: safeNum(obj?.hbzmy)    // 环比总码洋（元）
      })

      // 从大屏数据派生各周期原始对象
      const dayRaw = big?.tushuduoyuan_day || {}
      const weekRaw = big?.tushuduoyuan_week || {}
      const monthRaw = big?.tushuduoyuan_month || {}

      const hasBigData = (
        dayRaw && Object.keys(dayRaw).length > 0 ||
        weekRaw && Object.keys(weekRaw).length > 0 ||
        monthRaw && Object.keys(monthRaw).length > 0
      )

      if (hasBigData) {
        // 使用大屏数据：清洗并入库（不改变当前 period）
        commit('SET_TUSHUDUOYUAN', {
          day: normalizeDU(dayRaw),
          week: normalizeDU(weekRaw),
          month: normalizeDU(monthRaw)
        })
      } else {
        // 回退旧接口：同样进行清洗与入库
        const data = {}
        // 支持可能的字段命名差异（day/today）
        const dayApi = data?.day || data?.today || {}
        const weekApi = data?.week || {}
        const monthApi = data?.month || {}
        commit('SET_TUSHUDUOYUAN', {
          day: normalizeDU(dayApi),
          week: normalizeDU(weekApi),
          month: normalizeDU(monthApi)
        })
      }
    } catch (error) {
      console.error('获取图书统计数据失败:', error)
      // 失败时写入安全默认值，避免页面空白
      commit('SET_TUSHUDUOYUAN', {
        day: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
        week: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
        month: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 }
      })
    }
  }
}

const getters = {
  tushuduoyuanToday: state => state.tushuduoyuan.day,
  tushuduoyuanWeek: state => state.tushuduoyuan.week,
  tushuduoyuanMonth: state => state.tushuduoyuan.month,
  tushuduoyuanPeriod: state => state.tushuduoyuan.period
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
